import React, { useContext } from 'react';
import {
  ListItem,
  QuestionTitle,
  QuestionTitleText,
  QuestionContent,
  QuestionContainer,
  ExpandIcon,
} from './components';
import { purify } from '../../utils/helpers';
import UserContext from '../../../configuration/context/user';
import MarketContext from '../../../configuration/context/market';
import { premiumFAQExpansionEvent } from '../../../lib/tracking/eventPayloadDefinitions';
import { getCookie } from '../../../lib/cookie-utils';
import { trackEvent } from '../../../lib/tracking';

type QuestionPropTypes = {
  header: string;
  content: string;
  dataEventCategory?: string;
  dataEventAction?: string;
  dataEventLabel?: string;
};

function Question(props: QuestionPropTypes) {
  const {
    header,
    content,
    dataEventAction,
    dataEventCategory,
    dataEventLabel,
  } = props;

  const user = useContext(UserContext);
  const market = useContext(MarketContext);

  // When button is clicked, trigger a premiumStorefrontInteractionEvent
  const handleInteraction = (e: React.MouseEvent<HTMLDetailsElement>) => {
    const expandedOrCollapsed =
      e.currentTarget.parentElement?.getAttribute('open') === null
        ? 'expanded'
        : 'collapsed';
    const payload = {
      country: market?.country ?? 'unknown',
      locale: market?.language ?? 'unknown',
      full_url: window.location.href,
      timestamp: Math.floor(Date.now() / 1000),
      faq_interaction: `User - ${expandedOrCollapsed}: ${e.currentTarget.innerText}`,
      correlation_id: getCookie('sp_t') as string | null,
      is_evergreen: market?.isEvergreen,
      eligibility: user?.eligibility,
    };

    trackEvent(
      premiumFAQExpansionEvent(payload, {
        authorize: user.authenticated,
      }),
    );
  };

  return (
    <ListItem>
      <QuestionContainer>
        <QuestionTitle
          data-event-category={dataEventCategory}
          data-event-action={dataEventAction}
          data-event-label={dataEventLabel}
          onClick={handleInteraction}
        >
          <QuestionTitleText>{header}</QuestionTitleText>
          <ExpandIcon aria-hidden="true" />
        </QuestionTitle>
        <QuestionContent
          dangerouslySetInnerHTML={{ __html: purify(content) }}
        />
      </QuestionContainer>
    </ListItem>
  );
}

export default Question;
